import { Controller } from "@hotwired/stimulus"
import { useElementListener } from 'lib/event_helpers'
import * as Bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['canvas', 'swipeBlock', 'content']

  connect() {
    let touchListener = this.element;

    // Check if we have off canvas content that needs to scroll —
    // if we do we need the body to be scrollable then we'll make
    // this dismissable by swiping the swipeBlock instead of the
    // whole body of the offcanvas
    if (this.hasContentTarget && this.hasContentTarget) {
      const { contentTarget } = this;
      const { scrollHeight, clientHeight } = contentTarget;

      if (scrollHeight > clientHeight)
        touchListener = this.swipeBlockTarget;
    }

    useElementListener(this, touchListener, 'touchstart', this.touchStartHandler);
  }

  touchStartHandler = (e) => {
    let startY;
    let distY;

    const touchMoveHandler = (e) => {
      const touchobj = e.changedTouches[0];
      distY = touchobj.pageY - startY;

      // Check if the touch event originated from the link element or its descendants
      if (!this.isTouchEventOnLink(touchobj.target)) {
        e.preventDefault();
      }
    };

    const touchEndHandler = (e) => {
      if (distY > 100) {
        this.onSwipeDown();
      }

      this.element.removeEventListener('touchmove', touchMoveHandler);
      this.element.removeEventListener('touchend', touchEndHandler);
      this.element.removeEventListener('touchcancel', touchEndHandler);
    };

    const touchobj = e.changedTouches[0];
    startY = touchobj.pageY;
    distY = 0;

    if (!this.isTouchEventOnLink(touchobj.target)) {
      e.preventDefault();
    }

    this.element.addEventListener('touchmove', touchMoveHandler);
    this.element.addEventListener('touchend', touchEndHandler);
    this.element.addEventListener('touchcancel', touchEndHandler);
  };

  isTouchEventOnLink(element) {
    // Check if the element is the link itself
    if (element.tagName === 'A') {
      return true;
    }

    // Check if the element is a descendant of a link
    if (element.parentNode && element.parentNode.tagName === 'A') {
      return true;
    }

    // Recursively check the parent nodes
    if (element.parentNode) {
      return this.isTouchEventOnLink(element.parentNode);
    }

    return false;
  }

  onSwipeDown() {
    let offcanvas = Bootstrap.Offcanvas.getOrCreateInstance(this.canvasTarget);
    offcanvas.hide();
  }
}
